export const LIST = 'LIST';
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const VIEW = 'VIEW';

export const getPageName = (entityName) => ({
  list: `${entityName}S_${LIST}`,
  update: `${entityName}_${UPDATE}`,
  create: `${entityName}_${CREATE}`,
  view: `${entityName}_${VIEW}`,
  onlyPage: entityName,
});
